module.exports = __webpack_public_path__ + "static/media/Country-Place-Residents-Handbook.32bd247d.pdf";